import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    AppBar, Toolbar, Typography, Button, Box,
    Menu, MenuItem, Divider, Avatar,
} from '@mui/material';
import {
    Logout as LogoutIcon,
    Settings as SettingsIcon,
    ExpandMore as ChevronIcon,
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const NavBar = () => {
    const navigate  = useNavigate();
    const location  = useLocation();
    const { user, logout } = useAuth();

    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);

    const handleLogout = () => {
        setAnchorEl(null);
        logout();
        navigate('/');
    };

    const isAuthPage = location.pathname === '/login' || location.pathname === '/register';
    const isLanding  = location.pathname === '/';
    if (isAuthPage || isLanding || !user) return null;

    const initials = (
        (user.firstName?.[0] || '') + (user.lastName?.[0] || '')
    ).toUpperCase() || user.username?.[0]?.toUpperCase() || '?';

    return (
        <AppBar position="static" elevation={0}
            sx={{ borderBottom:'1px solid rgba(255,255,255,0.12)', bgcolor:'#7C3AED' }}>
            <Toolbar sx={{ gap:0.5 }}>
                {/* Brand */}
                <Typography variant="h6" fontWeight={800} letterSpacing={-0.3}
                    sx={{ cursor:'pointer', mr:2 }} onClick={() => navigate('/dashboard')}>
                    Quuip
                </Typography>

                <Box sx={{ flexGrow:1 }} />

                {/* User menu */}
                <Button color="inherit" onClick={e => setAnchorEl(e.currentTarget)}
                    endIcon={<ChevronIcon sx={{ fontSize:16, opacity:0.7 }} />}
                    sx={{ ml:0.5, borderRadius:2, px:1.5, fontWeight:600, '&:hover':{ bgcolor:'rgba(255,255,255,0.12)' }, textTransform:'none' }}>
                    <Avatar sx={{ width:28, height:28, bgcolor:'rgba(255,255,255,0.22)', fontSize:'0.75rem', fontWeight:700, mr:1, border:'1.5px solid rgba(255,255,255,0.3)' }}>
                        {initials}
                    </Avatar>
                    <Typography variant="body2" fontWeight={600} sx={{ opacity:0.9, maxWidth:120, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                        {user.firstName || user.username}
                    </Typography>
                </Button>

                <Menu anchorEl={anchorEl} open={menuOpen} onClose={() => setAnchorEl(null)}
                    transformOrigin={{ horizontal:'right', vertical:'top' }}
                    anchorOrigin={{ horizontal:'right', vertical:'bottom' }}
                    PaperProps={{ elevation:2, sx:{ borderRadius:3, mt:0.75, minWidth:180, border:'1px solid rgba(0,0,0,0.08)' } }}>
                    <Box sx={{ px:2, py:1.5 }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={700} sx={{ textTransform:'uppercase', letterSpacing:0.6, fontSize:'0.62rem' }}>
                            Signed in as
                        </Typography>
                        <Typography variant="body2" fontWeight={700} sx={{ mt:0.25 }}>{user.username}</Typography>
                    </Box>
                    <Divider />
                    <MenuItem onClick={() => { setAnchorEl(null); navigate('/settings'); }}
                        sx={{ gap:1.5, py:1.25, fontWeight:600, fontSize:'0.9rem' }}>
                        <SettingsIcon sx={{ fontSize:17, color:'text.secondary' }} />
                        Settings
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={handleLogout}
                        sx={{ gap:1.5, py:1.25, fontWeight:600, fontSize:'0.9rem', color:'#DC2626' }}>
                        <LogoutIcon sx={{ fontSize:17 }} />
                        Sign out
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default NavBar;
